import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import ContactForm from '../components/ContactForm';
import Seo from '../components/Seo';
import Main from '../components/Main';
import Container from '../components/Container';
import Facebook from '../icons/facebook.svg';
import Twitter from '../icons/twitter.svg';
import Linkedin from '../icons/linkedin.svg';
import Instagram from '../icons/instagram.svg';
import useSiteMetaData from '../hooks/use-site-metadata';

function Contact({ data }) {
  const { seo, pageTitle } = data.allMarkdownRemark.edges[0].node.frontmatter;
  const { facebook, twitter, linkedIn, instagram } = useSiteMetaData();
  return (
    <Layout>
      <Seo title={seo.title} description={seo.description} slug="/contact/" />
      <Main>
        <Container>
          <div className="pageHeader">
            <h1 className="heading1">{pageTitle}</h1>
          </div>
          <div className="contactInfo">
            <div className="contactInfo-column">
              <h2 className="heading2">Connect with us</h2>
              <p className="heading3">
                Collaborating with social networking and the sharing economy to
                improve health and wellness
              </p>
            </div>
            <div className="contactInfo-column">
              <h3 className="contactInfo-heading">Email</h3>
              <a className="contactInfo-email" href="mailto:info@opyl.ai">
                info@opyl.ai
              </a>
              <h3 className="contactInfo-heading">Address</h3>
              <p>
                Engine House
                <br />
                105 Wellington Street
                <br />
                St Kilda, VIC 3191
                <br />
                Australia
              </p>
            </div>
            <div className="contactInfo-column">
              <h3 className="contactInfo-heading">Follow Us</h3>
              <ul className="contactInfo-social">
                <li>
                  <a href={facebook}>
                    <Facebook />
                    <span>Facebook</span>
                  </a>
                </li>
                <li>
                  <a href={twitter}>
                    <Twitter />
                    <span>Twitter</span>
                  </a>
                </li>
                <li>
                  <a href={linkedIn}>
                    <Linkedin />
                    <span>Linkedin</span>
                  </a>
                </li>
                <li>
                  <a href={instagram}>
                    <Instagram />
                    <span>Instagram</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Container>
        <ContactForm />
      </Main>
    </Layout>
  );
}

Contact.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }).isRequired,
};

export default Contact;

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "contact" } } }
    ) {
      edges {
        node {
          frontmatter {
            seo {
              title
              description
            }
            pageTitle
          }
        }
      }
    }
  }
`;
